'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _constants = require('../../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _functional_utility = require('../../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = function (_React$PureComponent) {
  _inherits(Button, _React$PureComponent);

  function Button(props) {
    _classCallCheck(this, Button);

    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.anchorAttr = function () {
      if (!_this.props.downloadURL) {
        return {};
      }
      var download = _this.props.downloadURL.replaceAll('<', '');
      return {
        href: download
      };
    };

    _this.state = {
      buttonStyle: {}
    };

    _this.updateStyleOnClick = _this.updateStyleOnClick.bind(_this);
    _this.removeButtonStyle = _this.removeButtonStyle.bind(_this);
    _this.callBack = _this.callBack.bind(_this);
    return _this;
  }

  _createClass(Button, [{
    key: 'updateStyleOnClick',
    value: function updateStyleOnClick() {
      this.setState({
        buttonStyle: {
          "backgroundColor": "#52D8E6"
        }
      });
    }
  }, {
    key: 'removeButtonStyle',
    value: function removeButtonStyle() {
      this.setState({ buttonStyle: {} });
    }
  }, {
    key: 'callBack',
    value: function callBack() {
      if (this.props.buttonType === 'moreInfoButtonCTA') {
        var anchor = "#/";
        if (!(0, _ramda.isNil)(this.props.downloadURL) && this.props.downloadURL.includes(anchor)) {
          var anchorLoc = this.props.downloadURL.split(anchor).filter(Boolean);
          var tab = anchorLoc[0];
          var card = void 0;
          if (anchorLoc.length > 1) {
            card = anchorLoc[1];
          }

          (0, _functional_utility.scrollToCard)(window.document, tab, card, this.props.breakpoint);
        }
      }

      if (this.props.callBack) {
        this.props.callBack(this.props.type);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var additionalClassName = this.props.additionalClassName;

      if ((0, _ramda.includes)(this.props.role, _constants2.default.getExcludeRolesExcelDownloadButton())) {
        return null;
      }

      var buttonType = void 0;
      if (this.props.buttonType) {
        buttonType = this.props.buttonType;
      } else {
        buttonType = 'downloadButton';
      }

      var marginTop = void 0;
      var marginBottom = 'margin-bottom-20';
      if (this.props.buttonType === 'downloadButtonCTA') {
        marginTop = 'margin-top-10';
      } else if (this.props.buttonType === 'moreInfoButtonCTA') {
        marginTop = '';
        marginBottom = '';
      } else if (this.props.widerTopMargin) {
        marginTop = 'margin-top-50';
      } else {
        marginTop = 'margin-top-30';
      }

      return _react2.default.createElement(
        'a',
        _extends({}, this.anchorAttr(), {
          'data-testid': this.props.dataTestLink,
          id: this.props.dataTestLink,
          rel: 'nofollow',
          target: this.props.openInNewTab ? "_blank" : "_self",
          onClick: this.callBack,
          'aria-label': this.props.text + this.props.ariaLabel
        }),
        _react2.default.createElement(
          'div',
          { 'data-testid': this.props.dataTest,
            id: this.props.dataTest,
            className: buttonType + ' button ' + marginBottom + ' ' + marginTop + ' col-md-4 col-lg-3 col-xlg-3 print-hide ' + ((0, _ramda.isNil)(additionalClassName) ? "" : additionalClassName),
            onMouseDown: this.updateStyleOnClick,
            style: this.state.buttonStyle,
            onMouseUp: this.removeButtonStyle,
            onMouseOut: this.removeButtonStyle },
          _react2.default.createElement(
            'div',
            { className: '' + (this.props.buttonType ? this.props.buttonType + 'Text' : 'downloadButtonText') },
            _react2.default.createElement(
              'span',
              { style: this.state.buttonStyle },
              this.props.text
            )
          ),
          (0, _ramda.isNil)(this.props.buttonType) ? _react2.default.createElement('span', { className: "icon-button-button margin-left-10" }) : null
        )
      );
    }
  }]);

  return Button;
}(_react2.default.PureComponent);

exports.default = Button;